module.exports = __webpack_public_path__ + "static/media/blom-pysanky-20.7840cffa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-20.jpg
// module id = 3707
// module chunks = 15